import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Layout } from '../../components/layout/Layout';
import { PageHeader } from '../../components/layout/PageHeader';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { useAuth } from '../../contexts/AuthContext';
import { inviteStudent } from '../../modules/platform/api/schools';
import { showErrorToast, showSuccessToast } from '../../utils/errorHandler';
import { validateEmail } from '../../utils/validation';

interface InviteFormData {
  email: string;
}

export const InviteStudent: React.FC = () => {
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const schoolId = user?.memberships[0]?.school_id;

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<InviteFormData>();

  const onSubmit = async (data: InviteFormData) => {
    if (!schoolId) return;

    setIsLoading(true);
    try {
      await inviteStudent(schoolId, data.email);
      showSuccessToast('Invite sent successfully!');
      reset();
    } catch (error) {
      showErrorToast(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Layout>
      <PageHeader
        title="Invite Student"
        subtitle="Send an invitation to a student"
      />

      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>Invite Details</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            <Input
              label="Email Address"
              type="email"
              {...register('email', {
                required: 'Email is required',
                validate: (value) => validateEmail(value) || 'Invalid email address',
              })}
              error={errors.email?.message}
              placeholder="student@school.com"
              helperText="An invite will be sent to this email address"
            />

            <Button type="submit" isLoading={isLoading} className="w-full">
              Send Invite
            </Button>
          </form>
        </CardContent>
      </Card>
    </Layout>
  );
};

